// extracted by mini-css-extract-plugin
module.exports = {"body":"SaveSectionConfirmationModal_body__31Z4I"};